const states = {
    toggleForm: false,
};
const mutations = {
    hideForm(state) {
        state.toggleForm = false;
    },
    showForm(state) {
        state.toggleForm = true;
    },
};
const getters = {
    toggleForm(state) {
        return state.toggleForm;
    },
};
export default {
    namespaced: true,
    state: states,
    mutations,
    getters,
};
